import { CounterQuestionConfig } from '@gripp/shared-logic';
import { InlineFields } from '../components/printPrimitives';
import { PRINT_SHEET_CLASS as C } from '../printStyles';
import { RoutinePrintQuestion } from './types';

export const CounterPrintQuestion: RoutinePrintQuestion = ({ config }) => {
  const counter = config as CounterQuestionConfig;

  return (
    <InlineFields>
      <div className={`${C}__rule`} style={{ flex: '1 1 0' }} />
      {counter.uom ? (
        <span className={`${C}__optionText`} style={{ paddingBottom: 4 }}>
          {counter.uom}
        </span>
      ) : null}
    </InlineFields>
  );
};
